module.exports = __webpack_public_path__ + "img/bulk.4829f466.svg";